import { useController } from 'react-hook-form';
import {
  DatePickerWithCollapsibleCalendar,
  DatePickerWithCollapsibleCalendarProps,
} from 'ui/datePicker';
import { FieldProps } from './types';

type DatePickerFieldProps = FieldProps &
  Omit<DatePickerWithCollapsibleCalendarProps, 'date' | 'onDateChange'>;

export const DatePickerField = ({ name, defaultValue, ...props }: DatePickerFieldProps) => {
  const {
    field: { onChange, value },
    fieldState: { error },
  } = useController({
    name,
    defaultValue,
  });

  return (
    <DatePickerWithCollapsibleCalendar
      {...props}
      hasError={!!error}
      date={value}
      onDateChange={onChange}
    />
  );
};
